import { Spin } from 'antd';
import React, { FC, useState, useRef, useEffect } from 'react';
import { StlViewer } from "react-stl-viewer";
import { useScreenshot } from 'use-react-screenshot'
import { dataURLtoFile } from '../utils/utilsFunctions';


// const style = {
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '250px',
//   alignSelf: 'center'
  
// }
interface Props {
  url?: any
  style?: any
  autoScreenshot?: any
  setThumbnailImage?: any
}

const Img3D: FC<Props> = ({ url, style, autoScreenshot, setThumbnailImage }) => {
  // const ref = createRef();
  const modelDivRef = useRef(null);
  const [image, takeScreenshot] = useScreenshot()
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if(image && setThumbnailImage){
      const imageFile = dataURLtoFile(image);
      setThumbnailImage([{uid: imageFile.name, originFileObj: imageFile}]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [image])

  const getImage = () => {
    takeScreenshot(modelDivRef.current)
  }
  
  return (
    <div ref={modelDivRef} >
    <Spin spinning={loading} >
      <StlViewer
        style={style}
        orbitControls
        // floorProps={{
        //   gridWidth: 200,
        //   gridLength: 200
        // }}
        modelProps={{
          color: "#0A65B2",
          // scale: 2
        }}
        shadows
        url={url}
        onFinishLoading={() => {
          setLoading(false)
          if(autoScreenshot){
            setTimeout(getImage, 500)
          }
        }}
      />
    </Spin>
    </div>
  );
}
export default Img3D;